<div class="d-flex flex-column justify-content-between flex-grow-1 flex-shrink-1">
  <div class="modal-body">
    <div *ngIf="templateSelected === 'confirmContent'">
      <p class="purchase-confirmation-title">
        <ng-container *ngIf="marketplaceItemType == 'Marketplace'">{{ 'marketplace.confirm.message' | translate }}</ng-container>
        <ng-container *ngIf="marketplaceItemType == 'Event'">{{ 'events.confirm.message' | translate }}</ng-container>
        <ng-container *ngIf="marketplaceItemType == 'Product'">{{ 'products.confirm.message' | translate }}</ng-container>
      </p>
      <hr class="mt-0 mb-lg-5 mb-4 rewards-confirm-divider" />

      <ng-container *fgbWebsiteContentFeatureFlag="'fgbcl.feature.flag.confirmation.additional'">
        <div class="font-size-14 text-black fw-bold ps-3 mb-4 rewards-confirmation-additional">
          {{ 'marketplace.confirmation.additional' | translate }}
        </div>
      </ng-container>

      <div class="my-4 confirmation-details-section">
        <img
          class="confirm-modal-image"
          src="{{ marketplaceItem.ItemImageURL | contentImage: '7' : 'marketplace' }}"
          [useDefault]="true"
          [loyaltyType]="'marketplace'"
          draggable="false"
        />

        <div class="ps-lg-0 ps-3 pt-3 pt-lg-0">
          <!--Item Name-->
          <div class="purchase-confirmation-name mb-1">{{ marketplaceItem.DisplayName }}</div>
          <!--Item Details-->
          <ng-container *ngIf="attributeMappingID && selectedAttributes">
            <div class="mt-1">
              <div *ngFor="let attribute of selectedAttributes" class="confirmation-attribute-values mb-0 attribute">
                <span class="confirmation-attribute-name mpc-confirmation-spacing">{{ attribute.AttributeName }}:</span>
                <span
                  class="confirmation-attribute-value"
                  fgbclAttributeTransValue
                  [attributeList]="marketplaceItem.Attributes"
                  [attributeDataOrId]="attribute.RewardValueId"
                ></span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="validCustomFields">
            <div class="mt-2" *ngFor="let field of validCustomFields">
              <div *ngIf="field.customFieldValue" class="confirmation-custom-field-values mb-0 field">
                <span class="confirmation-custom-field-name mpc-confirmation-spacing">{{ field.customFieldName }}:</span>
                <span class="confirmation-custom-field-value">{{ field.customFieldValue }}</span>
              </div>
            </div>
          </ng-container>
          <div class="mt-2">
            <div class="quantity-value-section font-size-12 mb-0">
              <span class="quantity-title mpc-confirmation-spacing">{{ 'marketplace.quantity' | translate }}</span>
              <span class="quantity-value">{{ purchaseQuantity }}</span>
            </div>
          </div>
          <div class="mt-2" *ngIf="!marketplaceItem.EcashValue">
            <div id="points-value" class="point-value-section mb-0 font-size-12">
              <span class="point-title mpc-confirmation-spacing">{{ 'marketplace.points.value' | translate }}</span>
              <span *ngIf="marketplaceItem.PointValue > 0" class="point-value"
                >{{ marketplaceItem.PointValue * purchaseQuantity | number }}
                {{ 'fgbcl.currency.pts' | translate }}
              </span>
              <!--Display text if value is 0-->
              <span *ngIf="marketplaceItem.PointValue == 0" class="point-value"
                >{{ 'fgbcl.marketplace.item.free' | translate }}
              </span>
            </div>
          </div>
          <div class="mt-2" *ngIf="marketplaceItem.EcashValue > 0">
            <div id="ecash-value" class="ecash-value-section mb-0">
              <span class="ecash-title mpc-confirmation-spacing">{{ 'marketplace.ecash.value' | translate }}</span>
              <span class="ecash-value">{{ (purchaseQuantity * marketplaceItem.EcashValue) / 100 | FortressCurrencyPipe }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="templateSelected === 'confirmContentCardPayment'">
      <p>
        <b>{{ 'marketplace.card.confirm.message' | translate }}</b>
      </p>
      <div class="row">
        <div class="col-6 my-3">
          <label>{{ 'marketplace.quantity' | translate }}</label>
          <span class="material-icons align-middle me-1">shopping_basket</span>
          <span class="text-primary">{{ purchaseQuantity }}</span>
        </div>
        <div class="col-6 my-3">
          <label>{{ 'marketplace.card.merchant.price' | translate }}</label>
          <span class="material-icons align-middle me-1">emoji_events</span>
          <span id="merchant-price" class="text-primary">{{
            (marketplaceItem.MerchantValue / 100) * purchaseQuantity | FortressCurrencyPipe
          }}</span>
        </div>
      </div>
    </div>
  </div>
  <hr class="mt-0 mb-2" />
  <div class="modal-footer d-flex justify-content-end border-0 pb-2">
    <button id="cancel-button" type="button" class="btn btn-purchase-cancel" (click)="purchaseLoading.emit(false)">
      {{ 'modal.cancel' | translate }}
    </button>
    <button id="confirm-button" type="button" class="btn btn-purchase-confirm" [disabled]="clicked" (click)="purchase()">
      {{ 'modal.confirm' | translate }}
    </button>
  </div>
</div>
